import React from 'react';
import SuccessScreen from '../../Common/SuccessScreen';
import disclaimerIcon from './assets/disclaimer-icon.svg';

const PaymentPending = () => (
  <SuccessScreen
    icon={disclaimerIcon}
    title="Payment pending!"
    subtitle="This may take a few minutes. Please check after some time."
  />
);

export default PaymentPending;
